import { WHATSAPP_LINK } from "../data/siteConfig";

const FloatingWhatsApp = () => (
  <a
    href={WHATSAPP_LINK}
    target="_blank"
    rel="noreferrer"
    className="rs-whatsapp-float"
    aria-label="Chat on WhatsApp"
    title="Chat on WhatsApp"
    data-testid="floating-whatsapp-btn"
  >
    <i className="bi bi-whatsapp"></i>
  </a>
);

export default FloatingWhatsApp;
